const BASE_FONT_SIZE = 16;

type Props = {
  width?: number | string;
  height?: number | string;
};

const Placeholder: FC<Props> = ({ width, height, children }) => {
  return (
    <div
      style={{
        width: getSizeValue(width),
        height: getSizeValue(height),
      }}
      className="rounded-sm bg-gradient-to-r from-background to-secondary"
    >
      {children}
    </div>
  );
};

const getSizeValue = (size?: number | string) => {
  if (!size) {
    return undefined;
  }
  if (typeof size === "number") {
    return `${size / BASE_FONT_SIZE}rem`;
  }
  return size;
};

export default Placeholder;
